var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InvalidDocumentItem } from 'src/ui/views/dynamics/CaseGlobalViewPage/components/modals/IncompleteModal/InvalidDocumentItem';
import styles from './InvalidDocuments.module.scss';
export var InvalidDocuments = function (props) {
    var i18n = props.i18n, invalidDocumentsByApplicant = props.invalidDocumentsByApplicant, reasons = props.reasons, onReasonChange = props.onReasonChange;
    if (!invalidDocumentsByApplicant || invalidDocumentsByApplicant.length < 1) {
        return null;
    }
    var handleReasonChange = function (doc, values) {
        var newReasonForDoc = { docId: doc.code, refusalReasonLabels: values };
        var reasonsFiltered = reasons.filter(function (reason) { return reason.docId !== doc.code; });
        onReasonChange(__spreadArray(__spreadArray([], reasonsFiltered, true), [newReasonForDoc], false));
    };
    var getCurrentReasonsForDoc = function (doc) {
        var currentReasons = reasons.find(function (reason) { return reason.docId === doc.code; });
        return currentReasons ? currentReasons.refusalReasonLabels : [];
    };
    return (_jsx("ul", __assign({ className: styles.invalidDocumentsWrapper }, { children: invalidDocumentsByApplicant.map(function (applicantDocuments) {
            var applicant = applicantDocuments.applicant, invalidDocuments = applicantDocuments.invalidDocuments;
            var name = "".concat(applicant.firstName, " ").concat(applicant.lastName);
            return (_jsxs("li", __assign({ className: styles.invalidDocumentItemWrapper }, { children: [_jsx("p", __assign({ className: styles.invalidDocumentItemApplicant }, { children: name })), invalidDocuments.map(function (doc) { return (_jsx(InvalidDocumentItem, { i18n: i18n, doc: doc, currentReasons: getCurrentReasonsForDoc(doc), onReasonsChange: function (newValue) { return handleReasonChange(doc, newValue); } })); })] }), applicant.id));
        }) })));
};
